import Vue from "vue";
import errorMixin from "@/mixins/errorMixin";
import leftPanel from './components/LeftPanel.vue';
export default Vue.extend({
    mixins: [errorMixin],
    components: {
        leftPanel
    },
    props: {
        templateConfig: {}
    }
});
